import React, { useState, useEffect } from 'react';
import { getAllLogosByUser } from '../../services/Logo_service';
import { getUserDetails, } from '../../services/User_service';
import '../../css/mail.css';
import { Link } from 'react-router-dom';
import { faImage } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FaInfoCircle } from 'react-icons/fa';
import useAppContext from '../../hooks/useAppContext';
import { AppContextType } from '../../context/AppContext';
import { useDraftManager } from '../../hooks/useDraftManager';

const API_URL = process.env.REACT_APP_API_BASE;

interface AnnonceProps {
  onValidate: (isValid: boolean) => void;
  // onSubmit: (texteAnnonce: string) => void;
  txtAnnonce: string;
  societyType: string | string[];
  societeSelected: string;
  reference: string;
  entete: string;
  floid: string;
  annonceur: string;
  // denomination: string;
  isSubmitted: boolean;
  updateTxtAnnonce: (newTxt: string) => void;
  updateDenomination: (newTxt: string) => void;
  updateEntete: (newTxt: string) => void;
  updateFloid: (newTxt: string) => void;
  updateAnnonceur: (newTxt: string) => void;
  updateReference: (newTxt: string) => void;
  updatesocieteSelected: (newTxt: string) => void;
  // legalForm: string;
  updateLegalForm: (value: string) => void;
}

interface Logo {
  id: number;
  libelle: string;
  user_id?: number;
  floId?: string;
  logo_status: string;
}

interface ErrorsType {
  denomination?: string;
  texteAnnonce?: string;
  legalForm?: string;
  entete?: string;
  annonceur?: string;
  reference?: string
}

// Fonction pour formater le texte de l'annonce
const formatObjectText = (text: string): string => {
  // Remplacer tous les sauts de ligne par des espaces
  let formatted = text.replace(/\n/g, ' ');

  // Supprimer les espaces multiples et les espaces en début/fin
  formatted = formatted.replace(/\s+/g, ' ').trim();

  return formatted;
};

const Annonce: React.FC<AnnonceProps> = ({
  onValidate,
  // onSubmit,
  txtAnnonce,
  isSubmitted,
  updateTxtAnnonce,
  // denomination,
  updateDenomination,
  entete,
  updateEntete,
  annonceur,
  floid,
  updateFloid,
  updateAnnonceur,
  reference,
  updateReference,
  societeSelected,
  societyType,
  updatesocieteSelected,
  // legalForm,
  updateLegalForm
}) => {

  const {
    texteAnnonce, setTexteAnnonce,
    denomination, setDenomination,
    legalForm, setLegalForm,
    clientReference, setClientReference,
    choix, setChoix,
    draftFormData,
    setLogoLibelle,

  } = useAppContext() as AppContextType

  const [errors, setErrors] = useState<ErrorsType>({});
  const [selectedLogos, setSelectedLogos] = useState<number[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [logos, setLogos] = useState<Logo[]>([]);
  const [fullscreenImage, setFullscreenImage] = useState<string | null>(null);
  const [user, setUser] = useState({
    name: '',
    firstname: '',
    email: '',
    reference: '',
    civility: '',
    code_parrainage: '',
    adresse: '',
    number: '',
    country: '',
    postal_code: '',
    dateCreation: '',
    raison_social: '',
    code_SIREN: '',
    code_NAF: '',
    tv_intra: '',
    entete: '',
    status: '',
    is_validated: false
  });

  const options = Array.isArray(societyType) ? societyType : [societyType];


  const { pushDraftContent } = useDraftManager()


  const handleCheckboxChange = (logoId: number) => {
    setSelectedLogos((prevSelected) => {
      const isCurrentlySelected = prevSelected.includes(logoId);
      const newSelected = isCurrentlySelected
        ? prevSelected.filter(id => id !== logoId)  // Déselectionner
        : [logoId];  // Selectionner SEULEMENT ce logo (un seul à la fois)

      pushDraftContent({ selectedLogos: newSelected });

      const selectedLogo = logos.find(logo => logo.id === logoId);
      if (selectedLogo) {
        if (!isCurrentlySelected && selectedLogo.floId) {
          // Logo sélectionné
          updateFloid(selectedLogo.floId);
          setLogoLibelle(selectedLogo.libelle);
          console.log("✅ Logo sélectionné:", {
            id: logoId,
            floId: selectedLogo.floId,
            libelle: selectedLogo.libelle
          });
        }
        else if (isCurrentlySelected) {
          // Logo désélectionné
          updateFloid("");
          setLogoLibelle("");
          console.log("❌ Logo désélectionné");
        }
      }
      return newSelected;
    });
  };

  // Charger selectedLogos depuis draftFormData
  useEffect(() => {
    if (draftFormData) {
      try {
        const parsedData = typeof draftFormData === 'string' ? JSON.parse(draftFormData) : draftFormData;
        if (parsedData.selectedLogos && Array.isArray(parsedData.selectedLogos)) {
          setSelectedLogos(parsedData.selectedLogos);
        }
      } catch (error) {
        console.error('Erreur lors du chargement de selectedLogos depuis draftFormData:', error);
      }
    }
  }, [draftFormData]);

  useEffect(() => {
    const fetchUserData = async () => {
      setLoading(true);
      const userData = await getUserDetails();
      if (userData) {
        setUser({
          name: userData.name || '',
          firstname: userData.firstname || '',
          email: userData.email || '',
          reference: userData.reference || '',
          civility: userData.civility || '',
          code_parrainage: userData.code_parrainage || '',
          adresse: userData.adresse || '',
          number: userData.number || '',
          country: userData.country || '',
          postal_code: userData.postal_code || '',
          dateCreation: userData.createdAt ? new Date(userData.createdAt).toLocaleDateString() : '',
          raison_social: userData.raison_social || '',
          code_SIREN: userData.code_SIREN || '',
          code_NAF: userData.code_NAF || '',
          tv_intra: userData.tv_intra || '',
          entete: userData.entete || '',
          status: userData.status || '',
          is_validated: userData.is_validated || false
        });
      }
      setLoading(false);
    };

    fetchUserData();
  }, []);

  const enteteText = `${user.raison_social || ''} ${user.adresse || ''} ${user.postal_code || ''} ${user.country || ''}`;

  const handleSelectChangeSociete = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setLegalForm(event.target.value);
    pushDraftContent({ legalForm: event.target.value })
  };

  useEffect(() => {
    const fetchLogos = async () => {
      try {
        localStorage.removeItem('logos');
        const fetchedLogos = await getAllLogosByUser();
        // Ajouter le typage explicite ici
        const acceptedLogos = fetchedLogos.filter((logo: Logo) =>
          logo.logo_status === 'accepted'
        );

        setLogos(acceptedLogos);
        localStorage.setItem('logos', JSON.stringify(acceptedLogos));
      } catch (error) {
        console.error('Erreur lors de la récupération des logos:', error);
      }
    };

    fetchLogos();
  }, []);

  useEffect(() => {
    if (texteAnnonce) updateTxtAnnonce(texteAnnonce)
  }, [texteAnnonce])

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { id, value } = event.target;
    if (id === 'denomination') {
      setDenomination(value)
      pushDraftContent({ denomination: value })
    };
    if (id === 'reference') {
      setClientReference(value);
      pushDraftContent({ clientReference: value })
    }
    if (id === 'legalForm') {
      setLegalForm(value);
      pushDraftContent({ legalForm: value })
    }
    if (id === 'texteAnnonce') {
      setTexteAnnonce(value);
      updateTxtAnnonce(value);
      pushDraftContent({ texteAnnonce: value })
    }
  };

  const validate = () => {
    const newErrors: { denomination?: string; texteAnnonce?: string, legalForm?: string } = {};
    if (!denomination) newErrors.denomination = "Le champ 'Dénomination' est obligatoire.";
    if (!legalForm) newErrors.legalForm = "Le champ 'forme juridique' est obligatoire.";
    if (!formatObjectText(txtAnnonce)) newErrors.texteAnnonce = "Le champ 'Texte de l'annonce' est obligatoire.";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const choixOptions = [
    { value: 'option1', label: 'Pas en-tête' },
    { value: 'option2', label: 'En-tête sans logo' },
    { value: 'option3', label: 'En-tête avec logo' },
    { value: 'option4', label: 'Logo uniquement' },
  ];

  const openFullscreen = (image: string) => {
    setFullscreenImage(image);
  };

  useEffect(() => {
    onValidate(validate());
  }, [denomination, txtAnnonce, onValidate, legalForm]);

  const handleSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setChoix(event.target.value);
    const tempEntent = ['option2', 'option3'].includes(event.target.value) ? enteteText : ''
    updateEntete(tempEntent)
  };

  // useEffect(() => {
  //   // Réinitialise le texte de l'annonce à l'ouverture du mode libre
  //   updateTxtAnnonce('');
  // }, [])


  return (
    <div className="mt-2" style={{ width: "100%" }}>
      <div>
        <h6 className="border-bottom pb-2 bg-orange">EN-TETE DU CABINET</h6>
        {/* Choix d'en-tête */}
        {user.status !== "anonymous" && user.is_validated === true ? (<div className="mb-3 row">
          <label htmlFor="choix" className="col-sm-3 col-form-label">
            Choisir
          </label>
          <div className="col-sm-9">
            <select
              className="form-select"
              id="choix"
              onChange={handleSelectChange}
              value={choix}
            >
              {
                choixOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))
              }
            </select>
          </div>
        </div>
        ) : (
          !user?.is_validated && user?.status !== "anonymous" && (
            <div
              style={{
                width: "100%",
                padding: "15px",
                backgroundColor: "#E6F7FA",
                borderRadius: "8px",
                textAlign: "center",
                border: "1px solid #4BB0C0",
              }}
            >
              <span
                style={{
                  fontWeight: "bold",
                  fontSize: "18px",
                  color: "#4BB0C0",
                }}
              >
                Votre compte est en cours de validation, vous pourrez choisir un en-tête et un logo une fois validé.
              </span>
            </div>
          )
        )}


        {/* Affichage conditionnel basé sur le choix sélectionné */}
        {
          choix === 'option2' &&
          <div className="mb-3 row">
            <label htmlFor="choix" className="col-sm-3 col-form-label">En-tête du cabinet</label>
            <div className="col-sm-9">
              <input
                className="form-control w-100 custom-textarea"
                id="entete"
                defaultValue={enteteText}
                readOnly
                style={{ color: 'black' }}
              />
            </div>
          </div>
        }

        {
          choix === 'option3' &&
          <div className="bg-light p-3 ">
            <div>
              <label htmlFor="choix" className="col-sm-3 col-form-label">En-tête du cabinet</label>
              <div className="col-sm-9">
                <input
                  className="form-control w-100 custom-textarea"
                  id="entete"
                  readOnly
                  defaultValue={enteteText}
                  style={{ color: 'black' }}
                />
              </div>
            </div>
            <div className='ok mt-3 align-items-center'>
              {
                logos?.length ? logos.map((logo) => (
                  <div key={logo.id} className="col-md-2 mx-2">
                    <label>
                      <input
                        type="radio"
                        name='logoOption3Assiste'
                        value={floid}
                        checked={selectedLogos.includes(logo.id)}
                        onChange={() => handleCheckboxChange(logo.id)}
                      />
                      <div style={{ width: "125px", height: "125px" }}>
                        <img
                          src={`${API_URL}/${logo.libelle}`}
                          alt={`Logo ${logo.id}`}
                          id="card-img-top"
                          onClick={() => openFullscreen(logo.libelle)}
                          style={{ cursor: 'pointer', width: "100%", height: "100%", objectFit: "cover" }}
                        />
                      </div>
                    </label>
                  </div>
                ))
                  :
                  <p>
                    <FaInfoCircle size={35} className="bg-col me-2" />
                    Vous n'avez pas encore de logo, veuillez cliquer ici pour l'ajouter  <Link to="/home/gestion-logos" className=""><span className='bg-col' style={{ fontSize: '1.1em' }}>&laquo;
                      <FontAwesomeIcon icon={faImage} aria-hidden="true" className="ico mx-2" style={{ color: "#2A919D", marginBottom: '7px' }} />
                      Gestion des logos &raquo;</span> </Link>
                  </p>
              }
            </div>
          </div>
        }

        {
          choix === 'option4' &&
          <div className="bg-light p-3 ok">
            {
              logos?.length ? logos.map((logo) => (
                <div key={logo.id} className="col-md-2 mx-2">
                  <label>
                    <input
                      type="radio"
                      name="logoOption4Assiste"
                      checked={selectedLogos.includes(logo.id)}
                      onChange={() => handleCheckboxChange(logo.id)}
                    />
                    <div style={{ width: "125px", height: "125px", marginRight: "10px" }}>
                      <img
                        src={`${API_URL}/${logo.libelle}`}
                        alt={`Logo ${logo.id}`}
                        id="card-img-top"
                        onClick={() => openFullscreen(logo.libelle)}
                        style={{ cursor: 'pointer', width: "100%", height: "100%", objectFit: "cover" }}
                      />
                    </div>
                  </label>
                </div>
              ))
                :
                <p>
                  <FaInfoCircle size={35} className="bg-col me-2" />
                  Vous n'avez pas encore de logo, veuillez cliquer ici pour l'ajouter  <Link to="/home/gestion-logos" className=""><span className='bg-col' style={{ fontSize: '1.1em' }}>&laquo;
                    <FontAwesomeIcon icon={faImage} aria-hidden="true" className="ico mx-2" style={{ color: "#2A919D", marginBottom: '7px' }} />
                    Gestion des logos &raquo;</span> </Link>
                </p>
            }
          </div>
        }

        <h6 className="border-bottom pb-2 bg-orange" style={{ marginTop: "10px" }}>RAISON SOCIALE</h6>
        <p>
          Indiquer la raison sociale de la société ou la dénomination du Cabinet de Notaire annonceur ou l'état civil
          de la personne concernée par l'annonce. En option, vous pouvez ajouter une référence client.
        </p>

        <div className="mb-3 row">
          <label htmlFor="denomination" className="col-sm-3 col-form-label">Dénomination</label>
          <div className="col-sm-9">
            <input
              className={`form-control ${(errors.denomination && isSubmitted) ? 'is-invalid' : ''}`}
              type="text"
              id="denomination"
              value={denomination}
              onChange={handleInputChange}
            />
            {
              errors.denomination &&
              isSubmitted &&
              <small className="text-danger">{errors.denomination}</small>
            }
          </div>
        </div>

        <div className="mb-3 row">
          <label htmlFor="sociteChoice" className="col-sm-3 col-form-label">Choisir</label>
          <div className="col-sm-9">
            <select
              className={`form-select ${(errors.legalForm && isSubmitted) ? 'is-invalid' : ''}`}
              id="legalForm"
              name="sociteChoice"
              onChange={handleSelectChangeSociete}
              value={legalForm}
            >
              <option value="">Selectionner une forme juridique</option>
              {
                options.map((option, index) => (
                  <option key={index} value={option}>
                    {option}
                  </option>
                ))
              }
            </select>
            {
              errors.legalForm &&
              isSubmitted &&
              <small className="text-danger">{errors.legalForm}</small>
            }
          </div>
        </div>

        <h6 className="border-bottom pb-2">L'ANNONCE</h6>
        <div className="mb-3 row">
          <label htmlFor="texteAnnonce" className="col-sm-3 col-form-label">Texte de l'annonce</label>
          <div className="col-sm-9">
            <textarea
              className={`form-control ${(errors.texteAnnonce && isSubmitted) ? 'is-invalid' : ''}`}
              id="texteAnnonce"
              rows={3}
              value={texteAnnonce}
              onChange={handleInputChange}
            >
            </textarea>
            {
              errors.texteAnnonce &&
              isSubmitted &&
              <small className="text-danger">{errors.texteAnnonce}</small>
            }
          </div>
        </div>

      </div>
    </div>
  );
};

export default Annonce;